import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import Collection from '../components/Collection';
import CategoryBox from '../components/Category-box';
import {fetchCollectionIfNeeded} from '../actions/collection';
import {fetchHomeCategoriesIfNeeded, openCategory} from '../actions/categories';
import ErrorMessage from '../components/Error-message';
import {transformForHomePage} from '../services/category-transformer';

class Home extends React.Component {

  static fetchData(dispatch) {
    return Promise.all([
      dispatch(fetchHomeCategoriesIfNeeded()),
      dispatch(fetchCollectionIfNeeded()),
      dispatch(openCategory(null)),
    ]);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.mode.siteProfile.vertical !== nextProps.mode.siteProfile.vertical) {
      this.props.dispatch(fetchCollectionIfNeeded());
      this.props.dispatch(fetchHomeCategoriesIfNeeded());
    }
  }

  render() {
    const categories = transformForHomePage(this.props.categories.items);
    const loading = this.props.categories.isFetching;

    return (
      <div className="container-home">

        <Collection/>

        <div className="page-home">
          {categories.length || loading ?
            <div className="section section-pad"><h2 className="title"><FormattedMessage id="editor.browse.by"/></h2></div> : ''
          }
          <div className="categories-container-home">
            {!categories.length && !loading ? <ErrorMessage/> : ''}

            {loading ?
              <div className="circle-loader"></div> :

              <div className="categories-list-home section section-pad-left">
                {categories.map((category, i) =>
                  <CategoryBox category={category} key={i} dispatch={this.props.dispatch} biPosition={i + 1}/>
                )}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    categories: PropTypes.object.isRequired,
    dispatch: PropTypes.func,
    mode: PropTypes.object
  };
}


function mapStateToProps(state) {
  return {
    categories: state.categories.home,
    mode: state.mode
  };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./containers/Home.js